import { render, staticRenderFns } from "./PricingServiceFee.vue?vue&type=template&id=16e487d6&scoped=true&"
import script from "./PricingServiceFee.vue?vue&type=script&lang=js&"
export * from "./PricingServiceFee.vue?vue&type=script&lang=js&"
import style0 from "./PricingServiceFee.vue?vue&type=style&index=0&id=16e487d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e487d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
